import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import apiSlice from './api/api.slice';
import authReducer, { setLogout } from './auth/auth.slice';
import gloablReducer from './global/global.slice';
import projectEditorReducer from './post/post.slice';
import modelToolMappingWorkflowReducer from './modelToolMappingWorkflow/slice';
import projectGroupReducer from './projectGroup/projectGroup.slice';
import v2UploadReducer from '../pages/UploadV2/v2Upload.slice';

const logoutListener = createListenerMiddleware();

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    global: gloablReducer,
    projectEditor: projectEditorReducer,
    modelToolMappingWorkflow: modelToolMappingWorkflowReducer,
    projectGroup: projectGroupReducer,
    v2Upload: v2UploadReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // v2 upload keeps raw File handles in state until submit-time upload
        ignoredActions: ['v2Upload/addFiles'],
        ignoredPaths: [/^v2Upload\.files\.\d+\.file$/],
      },
    })
      .prepend(logoutListener.middleware)
      .concat(apiSlice.middleware),
  devTools: true,
});
// concat api slice middleware here
// dev tools based on env

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

logoutListener.startListening.withTypes<RootState>()({
  // signed out already: a reset would refetch /me and log out again, forever
  predicate: (action, _state, previous) =>
    setLogout.match(action) && previous.auth.isAuthenticated,
  effect: (_action, { dispatch }) => {
    dispatch(apiSlice.util.resetApiState());
  },
});
export default store;
